var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28599 14.7141C4.96055 14.3887 4.96055 13.861 5.28599 13.5356L13.5356 5.286C13.861 4.96056 14.3886 4.96056 14.7141 5.286C15.0395 5.61144 15.0395 6.13907 14.7141 6.46451L6.4645 14.7141C6.13906 15.0395 5.61143 15.0395 5.28599 14.7141Z",
    fill: "#0038FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1248 14.9582C13.6645 14.9582 13.2914 14.5851 13.2914 14.1248L13.2914 6.70859L5.87518 6.70859C5.41494 6.70859 5.04184 6.33549 5.04184 5.87525C5.04184 5.41502 5.41494 5.04192 5.87518 5.04192L14.1248 5.04192C14.585 5.04192 14.9581 5.41502 14.9581 5.87525L14.9581 14.1248C14.9581 14.5851 14.585 14.9582 14.1248 14.9582Z",
    fill: "#0038FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon_expand.53be5a992dc062c3706428211e786fa9.svg";
export { ForwardRef as ReactComponent };